
import { endPoints } from "@/constants/apiSetting";
import httpClient from "@/common/service/HttpClient";
const SpecialPaymentService = {
    getSpecialPaymentList(obj) {
        return httpClient.post(endPoints.getSpecialPaymentList, obj);
    },
    getSpecialPaymentDtl(obj) {
        return httpClient.post(endPoints.getSpecialPaymentDtl, obj);
    },
    saveSpecialPayment(obj) {
        return httpClient.post(endPoints.saveSpecialPayment, obj);
    },
    addSpecialPayment(obj) {
        return httpClient.post(endPoints.addSpecialPayment, obj);
    },
    deleteSpecialPayment(obj) {
        return httpClient.post(endPoints.deleteSpecialPayment, obj);
    },
    getSpecialPaymentMsg(obj) {
        return httpClient.post(endPoints.getSpecialPaymentMsg, obj);
    },
    importSpecialPayment(obj) {
        return httpClient.post(endPoints.importSpecialPayment, obj);
    },
    printSpecialPayment(obj) {
        return httpClient.post(endPoints.printSpecialPayment, obj);
    },
    sendSpecialPayment(obj) {
        return httpClient.post(endPoints.sendSpecialPayment, obj);
    },
    approveSpecialPayment(obj) {
        return httpClient.post(endPoints.approveSpecialPayment, obj);
    },
    printSpecialPayment(obj) {
        return httpClient.post(endPoints.printSpecialPayment, obj);
    },
    exportSpecialPayment(obj) {
        return httpClient.post(endPoints.exportSpecialPayment, obj);
    },
}
export default SpecialPaymentService;


// WEBPACK FOOTER //
// ./src/service/SpecialPaymentService.js